<template>
  <div
    v-if="showActivities"
    class="participant-activity-manager mt-2 mb-4"
  >
    <h4>Curricular activities</h4>
    <div class="row">
      <div
        v-for="activityDay in eventActivities"
        :key="activityDay.date"
        class="col-lg-6"
      >
        <div class="card day">
          <div class="card-header">
            Day: {{ activityDay.date }}
          </div>
          <ul class="list-group list-group-flush">
            <li
              v-for="activity in activityDay.activities"
              :key="activity.id"
              class="list-group-item"
            >
              <div class="form-check form-check-inline">
                <input
                  :id="activityCbElId(activity)"
                  v-model="activity.selected"
                  type="checkbox"
                  class="form-check-input"
                  :disabled="readonly"
                >
                <label
                  :for="activityCbElId(activity)"
                  class="form-check-label"
                >
                  {{ fNameWithPrice(activity) }}
                </label>
              </div>
              <div
                v-if="showDetails(activity)"
                class="activity-details"
              >
                <div
                  v-if="activity.showDescription"
                  v-html="activity.description"
                />
                <div
                  v-if="showNotes(activity)"
                  class="mb-3"
                >
                  <label class="form-label">Notes (optional)</label>
                  <textarea
                    v-model="activity.notes"
                    class="form-control"
                    :readonly="readonly"
                  />
                </div>
              </div>
              <input
                v-model="activity.id"
                type="hidden"
                name="event_candidate[activities_attributes][][activity_id]"
              >
              <input
                v-model="activity.selected"
                type="hidden"
                name="event_candidate[activities_attributes][][selected]"
              >
              <input
                v-model="activity.notes"
                type="hidden"
                name="event_candidate[activities_attributes][][notes]"
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {computed, onMounted, ref, watch} from "vue"
import {isNonEmptyString} from "../js-utils"

interface RegistrationActivity {
  id: number;
  priceTypeId: number;
  name: string;
  price: number | string;
  selected: boolean;
  allowNotes: boolean;
  showDescription: boolean;
  description: string;
  notes: string;
}

interface ActivityDay {
  date: string;
  activities: RegistrationActivity[];
}

const props = defineProps({
  readonly: {default: false, type: Boolean},
  valueFieldRef: {type: String, default: null},
})

const eventActivities = ref<ActivityDay[]>([])
const valueFieldEl = ref<HTMLInputElement | null>(null)

const showActivities = computed((): boolean => {
  return Array.isArray(eventActivities.value) && eventActivities.value.length > 0
})

const activityCbElId = (activity: RegistrationActivity): string => {
  return `event-activity-${activity.id}`
}

const showNotes = (activity: RegistrationActivity): boolean => {
  return activity.selected && activity.allowNotes
}

const showDetails = (activity: RegistrationActivity): boolean => {
  return activity.selected && (activity.allowNotes || activity.showDescription)
}

const storeActivityData = (): void => {
  if (valueFieldEl.value) {
    valueFieldEl.value.value = JSON.stringify(eventActivities.value)
  }
}

const fNameWithPrice = (activity: RegistrationActivity): string => {
  if (activity.priceTypeId == 1) {
    let price = null as number | null
    if (typeof activity.price == "string") {
      price = parseFloat(activity.price)
    } else if (typeof activity.price == "number") {
      price = activity.price
    }
    if (price && !isNaN(price) && isFinite(price) && price > 0) {
      return `${activity.name} (${price.toFixed(2)} €)`
    } else {
      return `${activity.name} (--- €)`
    }
  } else if (activity.priceTypeId == 2) {
    return `${activity.name} (free)`
  } else {
    return activity.name || ""
  }
}

watch(
  eventActivities,
  () => {
    storeActivityData()
  },
  {deep: true}
)

onMounted(() => {
  if (isNonEmptyString(props.valueFieldRef)) {
    const field = document.querySelector(`input[ref="${props.valueFieldRef}"]`)
    if (field instanceof HTMLInputElement) {
      valueFieldEl.value = field
      try {
        const activityDays = JSON.parse(valueFieldEl.value.value)
        if (Array.isArray(activityDays)) {
          for (const dayData of activityDays) {
            if (isNonEmptyString(dayData.date) && Array.isArray(dayData.activities) && dayData.activities.length > 0) {
              eventActivities.value.push(dayData)
            }
          }
        }
      } catch {
        // pass
      }
    }
  }
})
</script>
